/**
 * Returns an answer array for question type `binary`
 *
 * @export
 * @param {*} answers
 * @returns
 */
export default function(answers) {
    return [
        {
            key: 'Yes',
            name: 'Yes',
            user: answers.filter((answer) => answer.value.find((kv) => kv.value == 'Yes'))
        },
        {
            key: 'No',
            name: 'No',
            user: answers.filter((answer) => answer.value.find((kv) => kv.value == 'No'))
        }
    ]
}
